import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(0);

  const faqs = [
    {
      category: 'Consultation Process',
      question: 'What happens during the free consultation?',
      answer: `Our free consultation is a comprehensive 45-minute strategy session where we:\n\n• Understand your business goals and current challenges\n• Analyze your existing digital presence\n• Discuss your target audience and market positioning\n• Explore potential solutions and strategies\n• Provide initial recommendations and next steps\n• Answer all your questions about our services and process\n\nThere's no sales pressure - just valuable insights to help you make informed decisions about your digital transformation.`
    },
    {
      category: 'Pricing & Timeline',question: 'How much do your services typically cost?',
      answer: `Our pricing varies based on project scope and complexity:\n\n• Web Development: ₹5,000 - ₹50,000+\n• Mobile App Development: ₹15,000 - ₹100,000+\n• Social Media Marketing: ₹2,000 - ₹10,000/month\n• Complete Digital Transformation: ₹20,000 - ₹200,000+\n\nWe provide detailed, transparent quotes after understanding your specific needs. Every project includes strategy, design, development, testing, and post-launch support. We also offer flexible payment plans to accommodate different budgets.`
    },
    {
      category: 'Project Timeline',question: 'How long does a typical project take?',
      answer: `Project timelines depend on scope and complexity:\n\n• Website Design & Development: 4-12 weeks\n• Mobile App Development: 12-24 weeks\n• Social Media Strategy Setup: 2-4 weeks\n• Complete Digital Transformation: 16-32 weeks\n\nWe provide detailed project timelines during consultation, including key milestones and deliverables. Rush projects are available with additional fees. We always aim to deliver on time while maintaining our quality standards.`
    },
    {
      category: 'Working Together',question: 'Do you work with businesses of all sizes?',
      answer: `Yes! We work with:\n\n• Startups and entrepreneurs just getting started\n• Small to medium businesses looking to grow\n• Established companies needing digital transformation\n• Enterprise clients requiring specialized solutions\n\nOur approach scales to match your needs and budget. Whether you're a solo entrepreneur or a Fortune 500 company, we tailor our services to deliver maximum value for your investment.`
    },
    {
      category: 'Support & Maintenance',
      question: 'What kind of support do you provide after project completion?',
      answer: `We believe in long-term partnerships:\n\n• 30-day bug-free guarantee on all projects\n• Comprehensive training for your team\n• Ongoing maintenance and support packages\n• Priority support for existing clients\n• Regular performance reviews and optimization\n• 24/7 emergency support for critical issues\n\nWe're not just service providers - we're your digital transformation partners for the long haul.`
    },
    {
      category: 'Getting Started',
      question: 'What information should I prepare for our consultation?',
      answer: `To make the most of our consultation, please prepare:\n\n• Your business goals and objectives\n• Current website and social media accounts\n• Target audience information\n• Competitor examples (what you like/dislike)\n• Budget range and timeline expectations\n• Any existing brand materials or guidelines\n• Specific challenges you're facing\n\nDon't worry if you don't have everything - we'll guide you through the discovery process and help identify what's most important for your success.`
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? -1 : index);
  };

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground">
            Everything you need to know about our consultation process, pricing, and working together.
          </p>
        </div>

        <div className="space-y-4">
          {faqs?.map((faq, index) => (
            <div
              key={index}
              className="bg-background rounded-xl border border-border overflow-hidden brand-transition hover:border-accent/50"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-surface/50 brand-transition"
              >
                <div>
                  <span className="text-xs font-medium text-accent uppercase tracking-wide mb-1 block">
                    {faq?.category}
                  </span>
                  <h3 className="font-semibold text-foreground">{faq?.question}</h3>
                </div>
                <Icon
                  name={openFAQ === index ? 'ChevronUp' : 'ChevronDown'}
                  size={20}
                  className="text-muted-foreground flex-shrink-0 ml-4"
                />
              </button>
              
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <div className="pt-2 border-t border-border">
                    <p className="text-muted-foreground whitespace-pre-line leading-relaxed">
                      {faq?.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Still Have Questions CTA */}
        <div className="mt-12 text-center">
          <div className="bg-gradient-to-r from-accent/10 to-trust/10 rounded-2xl p-8 border border-accent/20">
            <Icon name="HelpCircle" size={48} className="text-accent mx-auto mb-4" />
            <h3 className="text-xl font-bold text-foreground mb-2">
              Still Have Questions?
            </h3>
            <p className="text-muted-foreground mb-6">
              Can't find the answer you're looking for? We're here to help with any questions about 
              our services, process, or how we can help transform your digital presence.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:singhcreations23@gmail.com"
                className="inline-flex items-center justify-center space-x-2 px-6 py-3 bg-accent text-white rounded-lg hover:bg-accent/90 brand-transition"
              >
                <Icon name="Mail" size={18} />
                <span>Email Your Question</span>
              </a>
              <a
                href="tel:+917982843491"
                className="inline-flex items-center justify-center space-x-2 px-6 py-3 border border-accent text-accent rounded-lg hover:bg-accent/10 brand-transition"
              >
                <Icon name="Phone" size={18} />
                <span>Call Us Directly</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;